<template>
    <ValidationObserver class="geoPopup" ref="form" v-slot="{handleSubmit}">
        <div ref="geoPopup" class="geoPopup__fields">
            <div class="mb-4">
                <ValidationProvider
                    vid="name"
                    :name="$t('modals.Geo_name')"
                    rules="required|minmax:2,50"
                    v-slot="{ errors }"
                >
                    <vs-input class="w-full" :label="$t('modals.Geo_name')"
                              :placeholder="$t('modals.Enter_geo_name')" v-model="geo_name"
                    />
                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>
            <vs-card class="mb-4 w-full" v-for="(list, index) of inputList" :key="index">
                <vs-row type="flex" vs-align="center" class="justify-between">
                    <vs-col :vs-w="inputList.length > 1 ? 10 : 11">
                        <div class="w-full pr-4 pb-3">
                            <ValidationProvider
                                :vid="'country' +'_'+ index"
                                :name="$t('global.Country')"
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <label class="vs-input--label block w-full">{{ $t('global.Country') }}</label>
                                <v-select
                                    class="w-full"
                                    v-model="inputList[index].country"
                                    :clearable="false"
                                    :options="getUniqueCountries"
                                    @input="checkSelectedParameter()"
                                />
                                <span v-if="!inputList[index].country">
                                    <p v-for="(error, index) of errors" :key="index"
                                       class="text-danger text-xs">{{ error }}</p>
                                </span>
                            </ValidationProvider>
                        </div>
                        <div class="w-full pr-4">
                            <ValidationProvider
                                :vid="'language' +'_'+ index"
                                :name="$t('global.Languages')"
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <label class="vs-input--label block w-full">{{ $t('global.Languages') }}</label>
                                <v-select
                                    multiple
                                    clearSearchOnSelect
                                    :closeOnSelect="false"
                                    class="w-full"
                                    v-model="inputList[index].language"
                                    :options="language.options"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    @input="checkSelectedParameter()"
                                />
                                <span v-if="!inputList[index].language || !inputList[index].language.length">
                                    <p v-for="(error, index) of errors" :key="index"
                                       class="text-danger text-xs">{{ error }}</p>
                                </span>
                            </ValidationProvider>
                            <span
                                v-if="errorDuplicateCountry.show && errorDuplicateCountry.index === index"
                                class="text-danger text-xs"
                            >
                                {{
                                    $t('error.duplicate_country_and_lenguage_in_geo', {
                                        country: errorDuplicateCountry.country,
                                        language: errorDuplicateCountry.language,
                                        geo: errorDuplicateCountry.geo
                                    })
                                }}
                            </span>
                        </div>
                    </vs-col>
                    <vs-col v-if="index === inputList.length - 1" :vs-w="inputList.length > 1 ? 2 : 1"
                            class="flex justify-between">
                        <vs-button
                            v-if="index !== 0"
                            @click="removeFields(index)"
                            radius
                            color="primary"
                            type="filled"
                            v-bind="$iconData('icon-minus', 'fi-rr-minus-small')"
                            v-tooltip="$t('tooltip.Delete_country_and_language')"
                        />
                        <vs-button
                            @click.prevent="addFields"
                            radius
                            color="primary"
                            type="filled"
                            v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                            v-tooltip="$t('tooltip.Add_country_and_language')"
                        />
                    </vs-col>
                    <vs-col v-else vs-w="2">
                        <vs-button
                            @click="removeFields(index)"
                            radius
                            color="primary"
                            type="filled"
                            v-bind="$iconData('icon-minus', 'fi-rr-minus-small')"
                            v-tooltip="$t('tooltip.Delete_country_and_language')"
                        />
                    </vs-col>
                </vs-row>
            </vs-card>
        </div>
        <div class="text-right pt-4">
            <vs-button
                color="primary"
                @click="handleSubmit(sendGeo)"
                type="filled"
                :disabled="errorDuplicateCountry.show"
            >
                {{ $t('buttons.Save') }}
            </vs-button>
        </div>
    </ValidationObserver>
</template>

<script>
import vSelect from 'vue-select'
import {mapGetters, mapActions} from 'vuex'
import EventBus from '../../../store/eventBus'
import ErrorHandler from '@/utils/errorHandler'
import {ValidationObserver, ValidationProvider} from 'vee-validate'

export default {
    data() {
        return {
            geo_name: '',
            country: {
                select: [],
                options: []
            },
            language: {
                select: [],
                options: []
            },
            count: [],
            inputList: [{
                country: '',
                language: []
            }],
            errorDuplicateCountry: {
                country: null,
                language: null,
                geo: null,
                show: false,
                index: null
            }
        }
    },

    props: {
        popupData: {
            type: Object,
            require: true
        },
        popupButton: {
            type: String
        },
        popupType: {
            type: String
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },

    computed: {
        ...mapGetters(['geo']),

        getUniqueCountries() {
            return this.country.options.filter(country => !this.inputList.find(selectCountry => selectCountry.country.value === country.value))
        }
    },

    methods: {
        ...mapActions(['CREATE_GEOS', 'UPDATE_GEOS']),

        checkSelectedParameter() {
            for(let i = 0; i < this.inputList.length; i++) {
                const selectCountry = this.inputList[i].country.value
                const listGeo = this.popupType === 'addGeo' ? this.geo.geos : this.geo.geos.filter(geo => geo.id !== this.popupData.data.geo_id)
                if(this.inputList[i].language) {
                    for(let j = 0; j < listGeo.length; j++) {
                        const countryInGeo = listGeo[j].mapping[selectCountry]
                        if(countryInGeo) {
                            const duplicateLanguage = countryInGeo.find(item => this.inputList[i].language.some(language => language.value === item))
                            if(duplicateLanguage) {
                                this.errorDuplicateCountry = {
                                    country: this.inputList[i].country.label,
                                    language: this.geo.languages.find(language => language.iso_2 === duplicateLanguage).language,
                                    geo: listGeo[j].name,
                                    show: true,
                                    index: i
                                }
                                return
                            }
                        }
                    }
                }
                this.errorDuplicateCountry.show = false
            }
        },

        addFields() {
            this.inputList.push({
                country: '',
                language: []
            })
        },

        removeFields(index) {
            this.inputList.splice(index, 1)
        },

        async sendGeo() {
            try {
                const data = {
                    name: this.geo_name.trim(),
                    mapping: {}
                }
                for(const index in this.inputList) {
                    const key = this.inputList[index].country.value
                    data.mapping[key] = this.inputList[index].language.map(el => el.value)
                }

                if(this.popupType === 'editGeo') {
                    data.id = this.popupData.data.geo_id
                    await this.UPDATE_GEOS(data)
                } else {
                    await this.CREATE_GEOS(data)
                }

                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch(error) {
                if(error.response) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }

                if(typeof error.response.data.result === 'string') {
                    this.$vs.notify({
                        title: 'Error!',
                        text: error.response.data.result,
                        color: 'red',
                        iconPack: 'feather',
                        icon: 'icon-close'
                    })
                } else {
                    new ErrorHandler(error).send
                }
            }
        }
    },

    mounted() {
        try {
            const countries = this.geo.countries
            const languages = this.geo.languages

            this.country.options = countries.map(el => ({
                label: el.country,
                value: el.iso_2
            }))

            this.language.options = languages.map(el => ({
                label: el.language,
                value: el.iso_2
            }))

            if(this.popupType === 'editGeo') {
                this.geo_name = this.popupData.data.geo_name

                this.removeFields(0)

                for(const index in this.popupData.data.country) {
                    const obj = {
                        country: '',
                        language: []
                    }

                    const foundCountry = countries.find(el => el.iso_2 === this.popupData.data.country[index])
                    obj.country = {
                        label: foundCountry.country,
                        value: foundCountry.iso_2
                    }

                    for(const language of this.popupData.data.language[index]) {
                        const foundLanguage = languages.find(el => el.iso_2 === language)
                        obj.language.push({
                            label: foundLanguage.language,
                            value: foundLanguage.iso_2
                        })
                    }

                    this.inputList.push(obj)
                }
            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch(e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.geoPopup {
    &__fields {
        //max-height: 600px;
        //overflow-y: auto;
        //&::-webkit-scrollbar { width: 0; }
    }

    .vs__dropdown-option--selected {
        display: none !important;
    }
}
</style>
